import React, { useState, useContext, createContext } from 'react';
import './Home.css';
import videoSource from '../../src/assets/video/Futuristic CK Web Video v1.0.mp4';
import about2 from '../../src/assets/image/about/about2.jpg';

// Sample images for certifications/achievements – replace with your own


import { Typography, Card, Button } from 'antd';
const { Paragraph } = Typography;

// ----- React Context Example -----
const ThemeContext = createContext();

const ThemeDisplay = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  return (
    <div className={`react-demo-theme ${theme}`}>
      <p>Current Theme: <strong>{theme}</strong></p>
      <Button type="primary" onClick={toggleTheme}>
        Toggle Theme
      </Button>
    </div>
  );
};

const Home = () => {


  // ----- React useState Example -----
  const [count, setCount] = useState(0);

  // ----- React useContext Example -----
  const [theme, setTheme] = useState('light');
  const toggleTheme = () => setTheme(prev => prev === 'light' ? 'dark' : 'light');

  return (
   
      <div >
  
        {/* Hero Video */}
        <section className="hero-section">
          <video autoPlay muted loop playsInline className="hero-video">
            <source src={videoSource} type="video/mp4" />
          </video>
        </section>

        {/* About Me Section */}
        <br></br>
        <section className="homepage">
          <div className="about-photo-row">
            
            {[about2].map((img, index) => (
              <img key={index} src={img} alt={`About ${index + 1}`} className="about-photo" />
            ))}
          </div>

          <Paragraph className="intro-text">
  I am a <strong>Solutions Architect and Software Engineer</strong> specializing in <strong>AWS Cloud, Data Science, and Artificial Intelligence</strong>. 
  I excel at working with stakeholders to <strong>gather, analyze, and translate business requirements</strong> into scalable, secure, and high‑performing 
  technical solutions. My expertise covers <strong>cloud architecture, microservices, automation, and full‑stack development</strong> — ensuring that the 
  systems I design not only work technically but also align perfectly with business goals.
</Paragraph>

<Paragraph className="intro-text">
  In my role, I combine <strong>consulting skills</strong> with <strong>hands‑on technical execution</strong>. I engage with clients to understand their 
  operational challenges, propose the most effective cloud‑native strategies, and then personally lead the design, development, and deployment process. 
  Whether it’s building modern applications, optimizing workflows, or implementing cloud migrations, I ensure every solution is practical, maintainable, 
  and delivers measurable value.
</Paragraph>

<Paragraph className="intro-text">
  With a background in <strong>Data Science and AI</strong>, I apply advanced analytics to guide data‑driven decision‑making. One example is my 
  <strong>robust regression model</strong> that predicts the USA’s Consumer Price Index (CPI), which I have successfully applied to <strong>inform 
  stock market trading strategies</strong>. This unique combination of <strong>business acumen</strong> and <strong>deep technical capability</strong> 
  enables me to deliver solutions that work from both a technical and business perspective.
</Paragraph>


          {/* Highlights / Achievements */}
          <div className="awards-conveyor-container">
            
          </div>
        </section>

       
        
      </div>
    
  );
};

export default Home;
